import script from "./detailsInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./detailsInfo.vue?vue&type=script&lang=ts&setup=true"

import "./detailsInfo.vue?vue&type=style&index=0&id=b82a8fb2&scoped=true&lang=css"
import "./detailsInfo.vue?vue&type=style&index=1&id=b82a8fb2&lang=css"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b82a8fb2"]])

export default __exports__